/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useNavigate } from "react-router-dom";
// import logo from "./assets/28d77fccd23e3a575539bfdb89fd3cf1.png";
import { Button } from "@/shadcnComponents/ui/button";
import { RxExternalLink } from "react-icons/rx";
import { IoArrowForward } from "react-icons/io5";
import { twMerge } from "tailwind-merge";
import img_waitlist from "./assets/WaitlistImage.png";
import mixpanel from "mixpanel-browser";
import { useEffect, useRef, useState } from "react";
import { useInfluencer } from "@/Providers/Influencer";
import { useAuth } from "@/Providers/Auth";
import { PopupCard } from "../PublicProfile/Component";
import { FaLinkedinIn } from "react-icons/fa";
import { Input } from "@/shadcnComponents/ui/input";
import profilebuildinglogo from "./assets/loading-profile-building.gif";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shadcnComponents/ui/popover";
import { MdMenu } from "react-icons/md";
import axios from "axios";

const host = import.meta.env.VITE_BACKEND_SERVER_URL;

const FAqQuestionArray = [
  {
    title: "Who can join anchors|Collab?",
    point: (
      <span>
        We're open to all LinkedIn creators! <br />
        <br />
        If you have a LinkedIn account with a decent following and actively
        share valuable content, you're eligible to sign up.
      </span>
    ),
  },
  {
    title: "What happens after I sign up?",
    point: (
      <span>
        You simply build your profile showcasing your skills, personality, and
        content.
        <br />
        <br />
        Then publish it to get discovered by brands seeking creators like you!
      </span>
    ),
  },
  {
    title: "Do you take a cut of my earnings?",
    point: (
      <span>
        We have NO commissions! <br />
        <br />
        Your earning depends on your collab terms and brand agreements. Set your
        rates and keep 100% of what you agree on!
      </span>
    ),
  },
  {
    title: "What kind of brands will I work with?",
    point: (
      <span>
        From established names to rising stars, we have a diverse range of
        brands across various industries. <br />
        <br />
        We provide you with maximum chances of collaborations!
      </span>
    ),
  },
  {
    title: "Do you guarantee collaborations?",
    point: (
      <span>
        We connect you with ideal brands but success depends on your profile &
        campaign fit.
        <br />
        <br />
        We maximize your chances, but can't guarantee specific outcomes.
      </span>
    ),
  },
  {
    title: "How do I stand out?",
    point: (
      <span>
        Showcase your unique skills, personality, and content. <br />
        <br />
        The better your profile, the higher your chance to get "Featured" and
        seen by ALL browsing brands.
      </span>
    ),
  },
];

type LoginPopupProps = {
  onClose: () => void;
  backToSource?: boolean;
};

export const LoginPopup = ({ onClose, backToSource }: LoginPopupProps) => {
  const navigate = useNavigate();
  const authState = useAuth();
  const handleLinkedInLogin = async () => {
    if (authState?.loggedUser) {
      mixpanel.track("Clicked on my account");
      navigate(`/influencer/dashboard`);
    } else {
      localStorage.setItem("from", "linkedin");
      localStorage.setItem("authFor", "login");
      mixpanel.track("Linkedin Login Main page");
      authState?.handleOpenLinkedin({ backToSource: backToSource });
    }
  };

  const handleGoogleLogin = async () => {
    if (authState?.loggedUser) {
      mixpanel.track("Clicked on my account");
      navigate(`/influencer/dashboard`);
    } else {
      if (backToSource) {
        localStorage.setItem("back_to_source", "true");
        localStorage.setItem("signup_source", window.location.href);
      } // Save the current URL in localStorage
      localStorage.setItem("from", "google");
      localStorage.setItem("authFor", "login");
      mixpanel.track("Google Login Main page");
      window.open(
        `${import.meta.env.VITE_BACKEND_SERVER_URL}/google/auth`,
        "_self"
      );
    }
  };
  return (
    <PopupCard onClose={onClose}>
      <div className="mb-[20px]">
        <footer className="flex flex-col items-center justify-center">
          <div className="flex flex-col items-center justify-center">
            <img
              src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/airplane.svg"
              alt=""
              className="size-[20px]"
            />
            <p className="mb-6">Welcome !</p>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <div className=" flex flex-col self-stretch w-full items-start justify-center gap-3 ">
              <Button
                className="bg-[#0076b2] w-full gap-2 px-6 py-3 text-white md:font-bold text-[14px] md:text-[16px] not-italic leading-[normal] font-[Inter] items-center justify-start"
                onClick={() => {
                  handleLinkedInLogin();
                }}
              >
                {" "}
                {authState?.loggedUser ? (
                  "Go to my account →"
                ) : (
                  <>
                    <FaLinkedinIn size={20} />
                    Continue with LinkedIn →
                  </>
                )}
              </Button>

              {/* {!authState?.loggedUser && (
                <Button
                  variant="outline"
                  className="bg-white hover:bg-slate-200 w-full gap-2 px-6 py-3 text-black md:font-bold text-[14px] md:text-[16px] not-italic leading-[normal] font-[Inter] items-center justify-start"
                  onClick={() => {
                    handleGoogleLogin();
                  }}
                >
                  {" "}
                  {authState?.loggedUser ? (
                    "Go to my account →"
                  ) : (
                    <>
                      <FcGoogle size={20} />
                      Continue with Google →
                    </>
                  )}
                </Button>
              )} */}
            </div>

            {!authState?.loggedUser && (
              <p className="mb-4 text-xs text-[#757575]">
                By continuing, you agree to our{" "}
                <span
                  onClick={() =>
                    window.open(
                      "https://www.anchors.in/termsConditions",
                      "_blank"
                    )
                  }
                  className="underline cursor-pointer"
                >
                  T&C's
                </span>{" "}
                and{" "}
                <span
                  onClick={() =>
                    window.open(
                      "https://www.anchors.in/privacy-policy",
                      "_blank"
                    )
                  }
                  className="underline cursor-pointer"
                >
                  Privacy Policy
                </span>
              </p>
            )}
          </div>
        </footer>
      </div>
    </PopupCard>
  );
};

export const CreatorLandingPage = () => {
  const [LoadingPredictor, setLoadingPredictor] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [topInfluencer, setTopInfluencer] = useState([]);
  const [openLoginPopup, setOpenLoginPopup] = useState(false); // for login popup
  const [linkedLink, setLinkedLink] = useState({
    link: "",
    error: "",
    isValid: false,
  });

  const influencerState = useInfluencer();
  const targetRef = useRef(null);
  const targetRef2 = useRef(null);
  const authState = useAuth();
  const navigate = useNavigate();

  function handleContinue() {
    if (authState?.loggedUser) {
      mixpanel.track("Clicked on my account");
      navigate("/influencer/dashboard");
    } else {
      mixpanel.track("Clicked on Continue");
      // navigate("/influencer/login");
      setOpenLoginPopup(true);
    }
  }

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleLinkedEPALinkChange = (e: { target: { value: any } }) => {
    const inputLink = e.target.value;

    const linkedInUrlPattern =
      /^(https?:\/\/)?(www\.)?linkedin\.com\/in\/[a-zA-Z0-9-]{2,}\/?(\?.*)?$/;

    if (inputLink.length === 0) {
      setLinkedLink({ link: inputLink, error: "", isValid: false });
      return;
    }
    if (!linkedInUrlPattern.test(inputLink)) {
      setLinkedLink({
        link: inputLink,
        error:
          "Please enter a link in the format: https://www.linkedin.com/in/username",
        isValid: false,
      });
      return;
    }

    const strippedLink = inputLink?.split("?")?.[0];

    setLinkedLink({ link: strippedLink, error: "", isValid: true });
  };

  const handleSubmitGoEPAProfile = async () => {
    if (linkedLink?.isValid) {
      const parts = linkedLink?.link.split("/in/");
      const standardizedLink = `https://www.linkedin.com/in/${parts.pop()}`;
      setLinkedLink({ ...linkedLink, link: standardizedLink });

      mixpanel.track("Clicked on Go to EPA Profile", {
        link: standardizedLink,
      });

      let slug = null;
      try {
        setLoadingPredictor(true);
        const res = await axios.post(`${host}/in/create-guest-user`, {
          url: standardizedLink,
        });
        const { data } = res;
        if (data.success) {
          slug = data?.data?.slug;
        }
      } catch (error) {
        console.log("Linkedin  Predicctor: Some Error occurred!", error);
      } finally {
        setLoadingPredictor(false);
        let profileUrl = `/influencer/preview`;
        if (slug) {
          profileUrl = `/influencer/preview?s=${slug}`;
        }

        window.open(profileUrl, "_blank");
      }
    } else {
      setLinkedLink({
        ...linkedLink,
        error: "Please enter a valid LinkedIn profile link",
      });
    }
  };

  //mixpanel
  useEffect(() => {
    mixpanel.track("Visited Creator Landing Page");
  }, []);

  // Get Featured Creators
  useEffect(() => {
    const handleURLParams = () => {
      const params = new URLSearchParams(window.location.search);
      const referParam = params.get("refer");
      if (referParam) {
        localStorage.setItem("anchors_collab_refer", referParam);
      }
    };
    const getFeaturedCreators = async () => {
      const result = await influencerState?.getFeaturedCreators();
      if (result?.success) {
        setTopInfluencer(result?.topInfluencer);
      } else {
        console.log("Some Error occurred!");
      }
    };
    getFeaturedCreators();
    handleURLParams();
  }, []);

  // Floating Button
  const [isVisibleFloater, setIsVisibleFloater] = useState(false); // for floater visibility

  useEffect(() => {
    const handleIntersection = (entries) => {
      let isHeroVisible = false;
      let isFooterVisible = false;

      entries.forEach((entry) => {
        if (entry.target === targetRef.current) {
          isHeroVisible = entry.isIntersecting;
        }
        if (entry.target === targetRef2.current) {
          isFooterVisible = entry.isIntersecting;
        }
      });

      if (isHeroVisible || isFooterVisible) {
        setIsVisibleFloater(false);
      } else {
        setIsVisibleFloater(true);
      }
    };

    const observer = new IntersectionObserver(handleIntersection, {
      root: null, // viewport
      threshold: 0,
    });

    if (targetRef.current) {
      observer.observe(targetRef.current);
    }
    if (targetRef2.current) {
      observer.observe(targetRef2.current);
    }

    return () => {
      if (targetRef.current) {
        observer.unobserve(targetRef.current);
      }
      if (targetRef2.current) {
        observer.unobserve(targetRef2.current);
      }
    };
  }, []);

  const [mainBgImg, setMainBgImg] = useState(
    "url(https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/creatorlandingPage_assets/Background+Image.png) no-repeat"
  );

  useEffect(() => {
    if (window.innerWidth < 768) {
      setMainBgImg(
        "url(https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/creatorlandingPage_assets/Background+Image+(1).png) no-repeat"
      );
    }
  }, []);

  return (
    <>
      {openLoginPopup && (
        <LoginPopup onClose={() => setOpenLoginPopup(false)} />
      )}
      <div
        className="h-screen overflow-y-scroll text-[#FAFAFA] font-[Inter] relative"
        style={{ background: mainBgImg, backgroundSize: "cover" }}
      >
        <div className="mx-auto flex flex-col" id="creator">
          <NavBar
            setloginPopupControl={() => setOpenLoginPopup(true)}
            isPopupOpen={openLoginPopup}
          />

          {/* ------------ hero section ------------- */}
          <div className="min-h-[100svh] flex flex-col">
            <section className="flex flex-col justify-center items-center h-full text-center flex-1 px-[22px] md:px-[9%] relative">
              <img
                src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/CollabCreatorHomepage1.png"
                alt=""
                className="absolute z-[1]"
              />
              <div className="flex flex-col justify-center items-center z-[2]">
                <div className="md:text-xl font-bold leading-[28px] uppercase text-[#FF5C5C]">
                  For Creators
                </div>
                <h1 className="text-center text-[24px] md:text-[45px] font-bold leading-[normal]">
                  Get Noticed!
                  <br />
                  <span
                    style={{
                      background:
                        "linear-gradient(175deg, #FAFAFA 31.36%, #949494 95.66%)",
                      backgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Let Brands Find You
                  </span>
                </h1>
                <p className="text-[14px] md:text-[20px] tracking-[-0.28px] text-[#757575] pb-[40px]">
                  Connect & collaborate with perfect-matched <br />
                  brands. Elevate your LInkedIn influence!
                </p>
                <div className="px-3 w-full" ref={targetRef}>
                  <Button
                    variant="secondary"
                    className="rounded-3xl bg-white text-black w-full md:px-24 md:w-fit "
                    onClick={() => handleContinue()}
                  >
                    {authState?.loggedUser ? "My account" : "Continue"}
                    <IoArrowForward size={20} className="ml-2" />
                  </Button>
                </div>
                {isVisibleFloater && (
                  <div className="px-[22px] py-[14px] w-full  fixed bottom-0 right-0 left-0 z-[30] bg-black md:hidden">
                    <Button
                      variant="secondary"
                      className="rounded-md bg-white text-black shadow-md w-full"
                      onClick={() => handleContinue()}
                    >
                      {authState?.loggedUser ? "My account" : "Continue"}
                      <IoArrowForward size={20} className="ml-2" />
                    </Button>
                  </div>
                )}
                <div className="mt-4 flex items-center gap-2">
                  <div className="flex">
                    {topInfluencer?.slice(0, 3).map((item, index) => {
                      return (
                        <img
                          key={index}
                          src={item?.profile}
                          alt=""
                          className="size-[30px] rounded-full border-[2px] border-solid border-[#FF5C5C] -ml-3"
                        />
                      );
                    })}
                  </div>
                  <span className="text-[14px]">1000+ creators joined</span>
                </div>
              </div>
            </section>
          </div>

          {/* ---------- Creator of the Week ----------------- */}
          <section className="py-[56px] md:py-[96px] md:px-[9%] flex justify-center">
            <div className="max-w-[1367px] w-full">
              <div className="flex flex-col justify-center items-center text-center mb-10 space-y-2 md:space-y-3 px-[22px]">
                <div className="bg-[#FF5C5C52] rounded-3xl text-sm text-[#FF8A8A] px-8 py-2 w-fit">
                  WEEKLY CREATOR LIST
                </div>
                <h1 className="text-[28px] md:text-[40px] font-bold leading-[normal]">
                  Creators of The Week
                </h1>
                <p className="text-[#757575] text-center text-[14px] md:text-[20px] not-italic font-normal leading-[normal] md:leading-[28px]">
                  Discover high-impact influencers with thriving communities and
                  authentic connections, ready to amplify your brand!
                </p>
              </div>
              <div className="overflow-hidden w-full relative flex gap-[20px] items-center">
                <div className="block z-[1] absolute top-0 left-0 h-full w-[100px]  bg-gradient-to-l from-transparent to-black"></div>
                <div className="block z-[1] absolute top-0 right-0 h-full w-[100px]  bg-gradient-to-r from-transparent to-black"></div>
                <div className="flex gap-5 animate-slideRight justify-center items-center">
                  {topInfluencer?.map((item, index) => {
                    return (
                      <FeaturedCreatorCard
                        key={index}
                        creatorImg={item?.profile}
                        name={item?.name}
                        slug={item?.slug}
                      />
                    );
                  })}
                </div>
                <div className="flex gap-5 animate-slideRight justify-center items-center">
                  {topInfluencer?.map((item, index) => {
                    return (
                      <FeaturedCreatorCard
                        key={index}
                        creatorImg={item?.profile}
                        name={item?.name}
                        slug={item?.slug}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </section>

          {/* --------------- Why creators 💓 us ----------------- */}
          <section className="py-[56px] md:py-[96px] px-[22px] md:px-[9%] flex justify-center">
            <div className="max-w-[1367px] w-full">
              <div className="flex flex-col gap-[47px] md:gap-[76px] md:flex-row md:justify-between">
                <div className="text-center md:text-start md:w-1/2 flex flex-col justify-center">
                  <span className="md:text-xl font-bold leading-[28px] uppercase text-[#FF5C5C]">
                    Why creators 💓 us
                  </span>
                  <h1 className="text-[30px] md:text-[40px] not-italic font-bold leading-[normal]">
                    Detailed profile
                  </h1>
                  <p className="font-[Inter] text-[14px] leading-[normal] tracking-[-0.28px] text-[#757575] md:text-[20px] font-normal md:leading-[28px] md:tracking-[-0.4px]">
                    Without a single DM, let brands know you. Avoid low-ball
                    offers, spam & ghosting.
                  </p>
                </div>
                <div className="md:w-1/2 flex justify-center">
                  <img
                    src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/1718257650354-detailed_profile_range_ielem.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </section>

          {/* ------------COUNTER-OFFER ---------------- */}
          <section className="py-[56px] md:py-[96px] px-[22px] md:px-[9%] flex justify-center">
            <div className="max-w-[1367px] w-full">
              <div className="flex flex-col gap-[47px] md:gap-[76px] md:flex-row md:justify-between">
                <div className="text-center md:text-start md:w-1/2 flex flex-col justify-center">
                  <span className="md:text-xl font-bold leading-[28px] uppercase text-[#FF5C5C]">
                    Counter-offer
                  </span>
                  <h1 className="text-[30px] md:text-[40px] not-italic font-bold leading-[normal]">
                    You get to choose
                  </h1>
                  <p className="font-[Inter] text-[14px] leading-[normal] tracking-[-0.28px] text-[#757575] md:text-[20px] font-normal md:leading-[28px] md:tracking-[-0.4px]">
                    Does the deal not sound good? No problem! Suggest what you’d
                    be comfortable with.
                  </p>
                </div>
                <div className="md:w-1/2 flex justify-center">
                  <img
                    src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/1718194672309-Frame_1430101881.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </section>

          {/* ------------------- HOW IT WORKS ---------------- */}
          <section className="py-[56px] md:py-[96px] px-[22px] md:px-[9%] flex justify-center">
            <div className="max-w-[1367px] w-full">
              <div className="flex flex-col gap-[47px] md:gap-[76px]">
                <div className="text-center">
                  <span className="md:text-xl font-bold leading-[28px] uppercase text-[#FF5C5C]">
                    how it works
                  </span>
                  <h1 className="text-[30px] md:text-[40px] not-italic font-bold leading-[normal]">
                    4 simple steps!
                  </h1>
                </div>
                <div className="grid grid-cols-2 gap-[10px] sm:flex md:gap-[30px] justify-center flex-wrap self-stretch">
                  <HowItWorksCard
                    text="Sign Up in 2 Sec!"
                    imgUrl="https://cdn-icons-png.flaticon.com/512/9983/9983806.png"
                  />
                  <HowItWorksCard
                    text="Build Your Profile"
                    imgUrl="https://cdn-icons-png.flaticon.com/512/9983/9983866.png"
                  />
                  <HowItWorksCard
                    text="Get Discovered"
                    imgUrl="https://cdn-icons-png.flaticon.com/512/10004/10004333.png"
                  />
                  <HowItWorksCard
                    text="Collab & Get Paid!"
                    imgUrl="https://cdn-icons-png.flaticon.com/512/9558/9558762.png"
                  />
                </div>
              </div>
            </div>
          </section>

          {/* -------------------- REVENUE-SHARING ----------------- */}
          <section className="py-[56px] md:py-[96px] px-[22px] md:px-[9%] flex justify-center">
            <div className="max-w-[1367px] w-full">
              <div className=" flex flex-col gap-[47px] md:gap-[76px]">
                <div className="text-center">
                  <span className="md:text-xl font-bold leading-[28px] uppercase text-[#FF5C5C]">
                    Revenue-sharing
                  </span>
                  <h1 className="text-[30px] md:text-[40px] not-italic font-bold leading-[normal]">
                    Earn 40% on each unlock
                  </h1>
                  <p className="font-[Inter] text-[14px] leading-[normal] tracking-[-0.28px] text-[#757575] md:text-[20px] font-normal md:leading-[28px] md:tracking-[-0.4px]">
                    Many brands ghost creators after receiving information. With
                    this system, you get paid in advance, even if the
                    collaboration doesn’t happen.
                  </p>
                </div>
                <div className="grid grid-cols-2 gap-[10px] sm:flex md:gap-[30px] justify-center flex-wrap self-stretch">
                  <HowItWorksCard
                    text="Create anchors profile"
                    imgUrl="https://cdn3d.iconscout.com/3d/premium/thumb/id-card-8858043-7285379.png?f=webp"
                  />
                  <HowItWorksCard
                    text="Brand check Your profile"
                    imgUrl="https://cdn3d.iconscout.com/3d/premium/thumb/check-profile-6161394-5073628.png?f=webp"
                  />
                  <HowItWorksCard
                    text="Unlock By paying some payment"
                    imgUrl="https://cdn3d.iconscout.com/3d/premium/thumb/user-unlock-8858038-7285374.png?f=webp"
                  />
                  <HowItWorksCard
                    text="Voilla 40% money goes to you"
                    imgUrl="https://cdn3d.iconscout.com/3d/premium/thumb/money-bag-8567290-6777592.png?f=webp"
                  />
                </div>
              </div>
            </div>
          </section>

          {/* -------------------- EPA Linkedin predictor px-[22px] md:px-[9%] ------------------------- */}
          <section
            className="text-center md:text-start pt-[56px] md:pt-[96px] md:pb-0 flex justify-center bg-[#FF5C5C]"
            id="linkedin-epa"
          >
            <div className="max-w-[1367px] w-full ">
              <div className="px-[34px] pt-[34px] md:px-[74px] md:pt-[53px] md:pb-0 md:flex md:w-full relative space-y-[50px] md:space-y-0">
                <div className="w-full md:w-1/2">
                  <p className="text-[12px] md:text-xl font-bold leading-[28px] uppercase text-[#ffff]">
                    Linkedin analyser
                  </p>
                  <h1 className="text-[30px] leading-normal md:text-[40px] not-italic font-bold pt-[12px] pb-[8px] md:pt-[12px] md:pb-[20px] flex flex-col md:block">
                    Identify Your{" "}
                    <span className="underline">Earning Channels</span>
                  </h1>
                  <p className="font-[Inter] text-[14px] leading-[normal] tracking-[-0.28px] text-[#ffff] md:text-[20px] font-normal md:leading-[28px] md:tracking-[-0.4px]">
                    Analysed from your LinkedIn profile, find the best services
                    you can offer to brands. Preview your professional media kit
                    instantly.
                  </p>
                  <div className="w-full flex mt-[35px]">
                    <Input
                      className="shadow-lg rounded-r-none rounded-l-[10px] ring-2 ring-[#121212] text-black text-[12px] md:text-[16px] py-2 h-fit focus-visible:ring-offset-0"
                      type="text"
                      placeholder="Your LinkedIn profile link"
                      onChange={(e) => handleLinkedEPALinkChange(e)}
                      value={linkedLink?.link}
                    />
                    <button
                      className="shadow-lg flex items-center bg-black py-1 px-2 md:px-8 ring-2 ring-[#121212] rounded-l-none rounded-r-[10px] text-[18px] font-bold"
                      onClick={() => {
                        mixpanel.track("Clicked on Linkedin EPA Button");
                        handleSubmitGoEPAProfile();
                      }}
                      disabled={!linkedLink?.isValid}
                    >
                      {LoadingPredictor ? (
                        <img
                          src={profilebuildinglogo}
                          alt=""
                          className="w-6 animate-spin"
                        />
                      ) : (
                        <span className="hidden md:block">Check</span>
                      )}
                      <IoArrowForward size={24} className="ml-2" />
                    </button>
                  </div>
                  {linkedLink?.error && (
                    <p className="text-gray-200 text-[12px] mt-2">
                      {linkedLink?.error}
                    </p>
                  )}
                  <p
                    className="flex justify-center md:justify-start pt-4 text-[#121212] font-[Inter] text-[12px] md:text-[18px] font-bold leading-[normal] [text-decoration-line:underline] cursor-pointer"
                    onClick={() => {
                      mixpanel.track("Clicked on Get Linkedin Profile Button");
                      window.open("https://linkedin.com/in/me", "_blank");
                    }}
                  >
                    Get Linkedin Profile
                    <RxExternalLink className="ml-1 size-[18px] md:size-[24px]" />
                  </p>
                </div>
                <div className="w-full md:w-1/2 flex items-end justify-center md:justify-end">
                  <img
                    src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/1720611501997-creator-homepage-linkedin-analyzer-preview.png"
                    alt="mobile_preview"
                  />
                </div>
              </div>
            </div>
          </section>

          {/* ------------ FAQS ---------------- */}
          <section className="py-[56px] md:py-[96px] px-[22px] md:px-[9%] flex justify-center">
            <div className="max-w-[1367px] w-full">
              <div className="flex flex-col gap-[47px] md:gap-[76px] md:flex-row md:justify-between">
                <div className="text-center md:text-start md:w-1/4 md:flex md:flex-col md:justify-center">
                  <span className="md:text-xl font-bold leading-[28px] uppercase text-[#FF5C5C]">
                    FAQs
                  </span>
                  <h1 className="text-[30px] md:text-[40px] not-italic font-bold leading-[normal]">
                    Need a hand? We've got you.
                  </h1>
                </div>
                <div className="md:w-1/2">
                  <div className="w-full flex flex-col gap-[13px] md:gap-[24px] mx-auto">
                    {FAqQuestionArray.map((item, index) => (
                      <div
                        key={index}
                        className="w-full rounded-[4px] bg-[#252525] py-4 px-6  border-gray-300"
                      >
                        <div
                          className="w-full flex justify-between  items-center cursor-pointer transition duration-300 ease-in-out"
                          onClick={() => {
                            mixpanel.track(
                              `FAQ Question: ${index + 1}. Accordion Toggled`,
                              { question: item.title }
                            );
                            toggleAccordion(index);
                          }}
                        >
                          <span className="text-[#BDBDBD] text-[14px] md:text-[16px] not-italic md:font-semibold leading-normal">
                            {item.title}
                          </span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className={`h-6 w-6 transform transition-transform ${
                              activeIndex === index ? "rotate-180" : ""
                            }`}
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M19 9l-7 7-7-7"
                            />
                          </svg>
                        </div>
                        <div>
                          {activeIndex === index && (
                            <div className="pt-4 text-[14px] text-[#757575] transition-all duration-300 ease-in-out">
                              {item.point}
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* -----------------LAUNCHING SOON -------------- */}
          <section className="py-[56px] md:py-[96px] px-[22px] md:px-[9%] flex justify-center">
            <div className="max-w-[1367px] w-full">
              <div className="p-[34px] md:px-[74px] md:py-[53px] rounded-lg bg-[#252525] relative">
                <div className="w-full md:w-2/3">
                  <span className="text-[14px] md:text-xl font-bold leading-[28px] uppercase text-[#FF5C5C]">
                    Launching soon
                  </span>
                  <h1 className="text-[30px] md:text-[40px] not-italic font-bold leading-[normal] pt-[12px] pb-[8px] md:pt-[12px] md:pb-[20px]">
                    Not a LinkedIn Creator?
                  </h1>
                  <p className="font-[Inter] text-[14px] leading-[normal] tracking-[-0.28px] text-[#757575] md:text-[20px] font-normal md:leading-[28px] md:tracking-[-0.4px]">
                    Not a problem. We will be launching soon till be the first
                    one to get to know when we launch.
                  </p>
                  <Button
                    variant="secondary"
                    className="rounded-3xl bg-white text-black mt-[35px]"
                    onClick={() => {
                      mixpanel.track("Clicked on Join Waitlist Button");
                      window.open(
                        "https://bit.ly/join-waitlist-anchors",
                        "_blank"
                      );
                    }}
                  >
                    Join Waitlist
                    <IoArrowForward size={20} className="ml-2" />
                  </Button>
                </div>
                <img
                  src={img_waitlist}
                  alt=""
                  className="absolute top-0 right-0 md:top-auto md:scale-150 md:right-[12px] md:bottom-[16px]"
                />
              </div>
            </div>
          </section>
        </div>
        <div ref={targetRef2}>
          <Footer />
        </div>
      </div>
    </>
  );
};

const Footer = () => {
  const navigate = useNavigate();
  return (
    <div className="py-3 md:py-5 flex justify-between items-center px-[22px] md:px-[9%] bg-black z-[9999]">
      <img
        src="https://anchors-assets.s3.ap-south-1.amazonaws.com/anchors+logo+with+white+text.png" //"https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/Collab+White+Logo.svg" // "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/DiwaliLogoBlack.png" // "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/anchors_Christmas.svg"
        onClick={() => {
          navigate("/");
        }}
        alt=""
        className="w-32 md:w-44 cursor-pointer"
      />
      <Button
        size="sm"
        className="flex justify-center items-center text-xs rounded-3xl gap-2 md:gap-3 bg-[#212121] px-5 py-1"
        onClick={() => {
          mixpanel.track("Clicked on For Brand Footer Button");
          window.open(
            `https://www.anchors.in/waitlist/?ref=collab_homepage`,
            "_blank"
          );
        }}
      >
        For Brand
        <RxExternalLink
          size={20}
          color="#ff5c5c"
          className="size-[14px] md:size-[20px]"
        />
      </Button>
    </div>
  );
};

type NavBarProps = {
  setloginPopupControl?: (open: boolean) => void;
  isPopupOpen?: boolean;
};

const NavBar = ({ setloginPopupControl, isPopupOpen }: NavBarProps) => {
  const navigate = useNavigate();
  const authState = useAuth();

  function handleNavLoginBtn() {
    if (authState?.loggedUser) {
      navigate("/influencer/dashboard");
      mixpanel.track("Clicked on Go to my account");
    } else {
      // navigate("/influencer/login");
      setloginPopupControl(true);
      mixpanel.track("Clicked on Continue To Login");
    }
  }

  return (
    <div className="py-3 md:py-5 flex justify-between items-center px-[22px] md:px-[9%] sticky left-0 right-0 top-0 z-[100]">
      <img
        src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/Collab+White+Logo.svg" // "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/DiwaliLogoBlack.png" // "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/anchors_Christmas.svg"
        onClick={() => {
          navigate("/");
        }}
        alt=""
        className="w-32 md:w-44 cursor-pointer"
      />
      <div className="flex items-center justify-center gap-2">
        <div
          style={{
            background: "linear-gradient(to right, #FEAC5E, #C779D0, #4BC0C8)",
          }}
          className={`rounded-3xl p-0.5 flex items-center justify-center ${
            isPopupOpen && "filter blur"
          }`}
        >
          <Button
            size="sm"
            className={`flex justify-center items-center text-[14px] md:text-[16px] rounded-3xl gap-2 md:gap-3 bg-[#212121] px-5 py-1`}
            onClick={(e) => {
              e.preventDefault(); // Prevent default action if necessary
              // const section = document.getElementById('linkedin-epa');
              // if (section) {
              //   section.scrollIntoView({ behavior: 'smooth' });
              // }
              mixpanel.track("Clicked on Linkedin Analyser");
              window.open("#linkedin-epa", "_self");
            }}
            disabled={isPopupOpen}
          >
            <FaLinkedinIn
              size={20}
              color="#ff5c5c"
              className="size-[14px] md:size-[20px]"
            />
            <span className="hidden md:block">Linkedin Analyser</span>
            <span className="block md:hidden">Analyser</span>
          </Button>
        </div>
        <Button
          size="sm"
          className={`hidden md:flex justify-center items-center text-[14px] md:text-[16px] rounded-3xl gap-2 md:gap-3 bg-[#212121] px-5 py-1 ${
            isPopupOpen && "blur"
          }`}
          onClick={() => handleNavLoginBtn()}
          disabled={isPopupOpen}
        >
          {authState?.loggedUser ? "Go to my account" : "Continue To Login"}
          <RxExternalLink
            size={20}
            color="#ff5c5c"
            className="size-[14px] md:size-[20px]"
          />
        </Button>
        <Popover>
          <PopoverTrigger className="block md:hidden">
            <Button size="icon" className="bg-[#212121]">
              <MdMenu size={24} color="#ff5c5c" />
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-fit bg-black mt-2 mr-10 border-[#ff5c5c]/50">
            <div className="">
              <Button
                size="sm"
                className={`flex justify-center items-center text-[14px] md:text-[16px] rounded-3xl gap-2 md:gap-3 bg-[#212121] px-5 py-1 ${
                  isPopupOpen && "blur"
                }`}
                onClick={() => handleNavLoginBtn()}
                disabled={isPopupOpen}
              >
                {authState?.loggedUser
                  ? "Go to my account"
                  : "Continue To Login"}
                <RxExternalLink
                  size={20}
                  color="#ff5c5c"
                  className="size-[14px] md:size-[20px]"
                />
              </Button>
            </div>
          </PopoverContent>
        </Popover>
      </div>
    </div>
  );
};

export const FeaturedCreatorCard = ({
  creatorImg,
  name,
  slug,
}: {
  creatorImg: string;
  name: string;
  slug: string;
}) => {
  return (
    <section className="w-fit shrink-0  md:flex md:flex-col md:gap-[28px]">
      <div className="p-[10px] rounded-[8px] border-[1px] border-solid border-[#272727] backdrop-blur">
        <div className="relative size-[180px]">
          <img
            src={creatorImg}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src =
                "https://collab.anchors.in/FeatredCreatorBackground.png";
            }}
            alt={`Pic`}
            className="z-[1] object-cover h-full w-full rounded-[8px]"
          />
          <div
            className={twMerge(
              `z-[2] absolute top-0 left-0 right-0 bottom-0 bg-gradient-to-t from-[#171717] to-transparent`,
              `from-[#101010]`
            )}
          >
            <div className="flex flex-col justify-between w-full h-full">
              <div></div>
              <span className="w-full text-center text-white text-[16px] not-italic font-bold leading-[normal] font-[Inter] px-[16px]">
                {name}
              </span>
            </div>
          </div>
        </div>

        <div className="px-[16px] flex flex-col gap-[20px] bg-[#101010] rounded-b-[8px]">
          <div className="mt-[8px] flex justify-center">
            <div className="flex justify-center items-center gap-2 p-[6px] rounded bg-[linear-gradient(92deg,_rgba(241,_241,_241,_0.16)_1.57%,_rgba(243,_171,_171,_0.00)_49.29%,_rgba(241,_241,_241,_0.20)_96.06%)]">
              <div className="size-[12px]">
                <img
                  src={
                    "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/Lark20240610-154257.gif"
                  }
                  alt="logo"
                  className="w-full h-full"
                />
              </div>
              <span className="rounded text-white text-center text-[9px] not-italic font-bold leading-[normal] font-[Inter]">
                FEATURED
              </span>
            </div>
          </div>

          <div className="mb-[16px] flex flex-col items-center gap-4">
            <Button
              className="text-[#4E4E4E] font-[Inter] text-[12px] not-italic font-medium leading-[normal] w-full bg-black"
              onClick={() => {
                mixpanel.track("Clicked on Check Profile Button", {
                  creatorName: name,
                  slug: slug,
                });
                window.open(`${window.location.origin}/${slug}`, "_blank");
              }}
            >
              Check Profile
              <RxExternalLink size={16} color="#4E4E4E" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

const HowItWorksCard = ({
  text,
  imgUrl,
}: {
  text: string;
  imgUrl?: string;
}) => {
  return (
    <div className="rounded-lg bg-[#252525] flex flex-col gap-4 justify-center items-center  py-[24px] w-full sm:w-fit md:w-[253px]">
      <img src={imgUrl} alt="" className="size-[80px]" />
      <span className="text-[#FF5C5C] text-[12px] sm:text-[20px] font-bold md:leading-[28px] px-[8px] md:px-[22px] uppercase text-center text-wrap">
        {text}
      </span>
    </div>
  );
};
